// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"9e316660","369":"c8f106f5","755":"4d8f45e0","923":"157a629e","992":"a91e73bf"}[chunkId] + ".css";
};